<template>
  <div v-if="client" :class="{'has-text-grey is-abbr-like is-size-7': owner}">
    <span v-if="owner" class="has-text-weight-bold">Proprietario</span>
    <div v-if="client.business_name">{{client.business_name}}</div>
    <div v-if="client.business_name && (client.name || client.surname)"><small class="has-text-grey is-abbr-like" :title="$fullname(client)">{{$fullname(client)}}</small></div>
    <div v-if="!client.business_name">{{$fullname(client)}}</div>
    <div v-if="showIcons" class="has-text-grey">
      <font-awesome-icon v-if="client.business_name" icon="building" class="mr-2" title="Ragione sociale" />
      <font-awesome-icon v-if="client.name || client.surname" icon="user" class="m-0" title="Nome e cognome" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['client', 'owner', 'showIcons']
}
</script>